import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import OnlineDot from "shared/components/OnlineDot";
import BoostBolt from "shared/components/BoostBolt";

import "./UserInfo.scss";

const UserInfo = ({ className, name, age, location, likes, online, center }) => (
	<div className={classnames("userInfo", className, {
		"userInfo--center": center,
	})}>
		<h3 className="userInfo-username">
			<span className="userInfo-username-name">
				{name}{age && `, ${age}`}
			</span>
			{online && (
				<OnlineDot className="userInfo-username-online" />
			)}
			{!!(likes && likes.via_spotlight) && (
				<BoostBolt className="userInfo-username-isViaBoost" />
			)}
		</h3>
		{location && (
			<div className="userInfo-meta">
				<span className="userInfo-meta-location">{location}</span>
			</div>
		)}
	</div>
);

UserInfo.propTypes = {
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	age: PropTypes.number,
	location: PropTypes.string,
	likes: PropTypes.shape({
		via_spotlight: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.bool,
		]),
	}),
	online: PropTypes.bool,
	center: PropTypes.bool,
};
UserInfo.defaultProps = {
	className: "",
	age: null,
	location: null,
	likes: null,
	online: false,
	center: false,
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/shared/components/UserInfo.jsx